import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col text-left content-container flex-wrap gap-y-4" }
const _hoisted_2 = { class: "bold-text" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "flex flex-col gap-1" }
const _hoisted_5 = { class: "text-base leading-[20px]" }
const _hoisted_6 = { class: "text-muted text-base leading-[20px]" }


import { Subscription } from "@/types/auth";
import { formatLocalDate } from "@/utils/date";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'ActiveSubscriptionCard',
  props: {
    subscription: {},
    isLoading: { type: Boolean }
  },
  emits: ["cancelSubscription"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)(`subscription.${__props.subscription.calculator}.name`)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)(`subscription.plans.${__props.subscription.tiers[0]}`)), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)("subscription.plan-active-to", {
              date: _unref(formatLocalDate)(__props.subscription.period_end, "."),
            })), 1)
      ]),
      (__props.subscription.ends_at === null)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass(["bg-ternary text-black px-4 py-2 rounded-full", {
          'opacity-25 pointer-events-none': __props.isLoading,
        }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancelSubscription')))
          }, _toDisplayString(_unref(t)("buttons.subscription.cancel-subscription")), 3))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})